export const SIZES = {
    medium: 'medium',
    large: 'large',
};
export const THEMES = {
    onGrayBackground: 'onGrayBackground',
    onWhiteBackground: 'onWhiteBackground',
    onDarkBackground: 'onDarkBackground',
};
export const DATA_HOOKS = {
    ITEM_WRAPPER: 'item_wrapper',
    BREADCRUMB_CLICKABLE: 'breadcrumb-clickable',
    BREADCRUMBS_ITEM: 'breadcrumbs-item',
};
export const DATA_ATTRIBUTES = {
    DATA_ACTIVE: 'data-active',
    DATA_POSITION_ID: 'data-position-id',
    DATA_SIZE: 'data-size',
    DATA_THEME: 'data-theme',
};
//# sourceMappingURL=constnats.js.map